import IDMGlobals from './../IDMGlobals';
import IDMUtils from './../IDMUtils';
//
export default class IDMUser {
  constructor(datasource) {
    this.datasource = datasource;
  }
  async changePassword(optCtx) {
    await this.datasource.urlmanager.redirectRequest(this.datasource.opts.externalAuthDomain, '/' + IDMGlobals.URL_ChangePassword, 
      null,  null, null, optCtx, true
    );
  }

  async confirmPasswordResetAndLogin(newPassword, resetCode, username) {
    this.isAutheticating = true;
    //request federated login
    const resp = await this.datasource.api.password.confirmReset({ username, resetCode, newPassword });
    if (!this.datasource.opts || !this.datasource.opts.disableLogs) console.debug("Validation resp: ", resp)
    //internall processing
      // #Improvement -- on password reset like that, user is 100% not logged, so we don't need session handling at failure because
      //the reset haven't succeeded, so still not under authentication domain
    await this.datasource.handleAuthenticationResponse(resp, username, false);
    this.isAutheticating = false;
    //return response for user
    return resp;
  }
}
